// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowItem_root__2tC9L","arrow":"ArrowItem_arrow__3Jsgx","text":"ArrowItem_text__27Wmw"};